import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { membersApi, membersError } from '../../services/membersApi.ts';
import { Card, Field, MembersShell, Notice, primary } from './MembersShared.tsx';
import {MARKETING_CONSENT_VERSION} from '../../services/membersEmailApi.ts';
import MembersMarketingOptIn from './MembersMarketingOptIn.tsx';
import MembersAsaasSeal from './MembersAsaasSeal.tsx';
export {MembersLanding} from './MembersLanding.tsx';
export function MembersAuth({
  register = false
}: {
  register?: boolean;
}) {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setError('');
    const data = new FormData(event.currentTarget);
    try {
      const credentials = {
        email: String(data.get('email')).trim(),
        password: String(data.get('password'))
      };
      if (register) await membersApi.register({
        ...credentials,
        name: String(data.get('name')).trim(),
        phone: String(data.get('phone')).trim(),
        marketing_opt_in: data.get('marketing_opt_in') === 'on',
        ...(data.get('marketing_opt_in') === 'on' ? {marketing_consent_version: MARKETING_CONSENT_VERSION} : {})
      });else await membersApi.login(credentials);
      navigate('/members/portal', {
        replace: true
      });
    } catch (err) {
      setError(!register && (err as {
        response?: {
          status?: number;
        };
      })?.response?.status === 401 ? 'E-mail ou senha incorretos.' : membersError(err));
    } finally {
      setBusy(false);
    }
  }
  return <MembersShell>
    <Card className="mx-auto max-w-lg">
      <h1 className="text-2xl font-semibold">{register ? 'Comece sua parceria' : 'Bem-vindo de volta'}</h1>
      <p className="mt-2 mb-6 text-sm opacity-75">{register ? 'Para agências, profissionais de marketing e clientes Sminy que indicam clínicas. Crie seu acesso e complete o cadastro financeiro na sua área.' : 'Entre na sua área de parceiro para acompanhar as clínicas indicadas e suas comissões.'}</p>
      <form onSubmit={submit} className="space-y-4">{register && <Field label="Nome completo" name="name" autoComplete="name" required maxLength={150} />}
        <Field label="E-mail" name="email" type="email" autoComplete="email" required maxLength={254} />{register && <Field label="Telefone com DDD" name="phone" type="tel" autoComplete="tel" required maxLength={20} />}
        <Field label="Senha" name="password" type="password" autoComplete={register ? 'new-password' : 'current-password'} minLength={register ? 12 : undefined} maxLength={128} required />{register && <p className="text-xs opacity-75">Use pelo menos 12 caracteres. Seus dados serão utilizados para gerenciar a parceria e o cadastro financeiro.</p>}{register && <MembersMarketingOptIn />}{error && <Notice error>{error}</Notice>}
        {!register && <Link className="members-link inline-flex min-h-[40px] items-center text-sm underline" to="/members/forgot-password">Esqueci minha senha</Link>}
        <button disabled={busy} className={`${primary} w-full`}>{busy ? 'Aguarde...' : register ? 'Criar minha conta' : 'Entrar'}</button>
      </form>
      <p className="mt-6 text-sm">
        <Link className="underline" to={register ? '/members/login' : '/members/register'}>{register ? 'Já tenho uma conta' : 'Quero me cadastrar'}</Link>
      </p>
      <MembersAsaasSeal />
    </Card>
  </MembersShell>;
}
export function MembersReferral() {
  const {
    code = ''
  } = useParams();
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setBusy(true);
    setError('');
    try {
      await membersApi.refer({
        code,
        consent: true,
        clinic_name: String(data.get('clinic_name')),
        contact_name: String(data.get('contact_name')),
        email: String(data.get('email')),
        phone: String(data.get('phone'))
      });
      setSent(true);
    } catch (err) {
      setError(membersError(err));
    } finally {
      setBusy(false);
    }
  }
  return <MembersShell>
    <Card className="mx-auto max-w-lg">
      <h1 className="text-2xl font-semibold">Conheça a Sminy para sua clínica</h1>
      <p className="my-4 text-sm opacity-75">Conheça a Sminy por indicação de quem já faz parte da nossa rede. Preencha os dados da sua clínica para conversar com nossa equipe. A indicação será vinculada a quem compartilhou este link.</p>{sent ? <Notice>Recebemos seu interesse. Nossa equipe entrará em contato.</Notice> : <form onSubmit={submit} className="space-y-4">
        <Field label="Nome da clínica" name="clinic_name" required maxLength={150} />
        <Field label="Seu nome" name="contact_name" required maxLength={150} />
        <Field label="E-mail" name="email" type="email" required maxLength={254} />
        <Field label="Telefone com DDD" name="phone" type="tel" required maxLength={20} />
        <label className="flex items-start gap-3 text-sm">
          <input type="checkbox" required className="mt-1" />Autorizo o contato da Sminy sobre esta solicitação.</label>{error && <Notice error>{error}</Notice>}
        <button className={primary} disabled={busy || !code}>{busy ? 'Enviando...' : 'Tenho interesse'}</button>
      </form>}</Card>
  </MembersShell>;
}
